export default __webpack_public_path__ + "static/media/RedClockDark.a64e3621.png";